import axios from 'axios';
import { IMyOwnTractorImage } from '../../../interfaces/OwnTractor.interfaces';
import { tractorImageType } from '../../../store/userSellTractorSurveySlice';
import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from '../../product/queries/getUsersOwnTractors';

export interface IOwnTractorImage extends Pick<IMyOwnTractorImage, 'type' | 'url'> {}

export interface IPostMyOwnTractorImagesParams {
  reqBody: {
    ownTractorId: string;
    images: IOwnTractorImage[];
  };
}

export const postMyOwnTractorImages = ({ reqBody }: IPostMyOwnTractorImagesParams) => {
  return customAxios.post(`${usersOwnTractorsApiUrl}/mine/${reqBody.ownTractorId}/images`, reqBody.images);
};
